import utils from "./utils"

const WEBBASE = "https://start.exactonline.nl/docs/"
const PURCHASEORDERURL = new URL(WEBBASE + "PurEntryPurchOrder.aspx?BCAction=1")
const SALESORDERURL = new URL(WEBBASE + "SlsSalesOrderEntry.aspx?BCAction=1")
const WAREHOUSETRANSFERURL = new URL(WEBBASE + "InvWarehouseTransfer.aspx?BCAction=1")
const PLANNEDSALESRETURNURL = new URL(WEBBASE + "SlsShipmentReturnHistory.aspx?BCAction=1")

export const ORIGINAL_API_BASE = "https://start.exactonline.nl/"

const ORIGINAL_API_BASE_RE = new RegExp("^" + utils.escapeRegExp(ORIGINAL_API_BASE))
export function rewriteApiUrlStringFromOriginalToNew(s: string): string {
  return s.replace(ORIGINAL_API_BASE_RE, API_BASE)
}

const {REDIRECT_URI, CLIENT_ID} = process.env.NODE_ENV === "development" ?
  {REDIRECT_URI: "https://local.claude.nl:3000/OAuthResponse",
    CLIENT_ID: "fb9dfa98-173c-412d-8ab8-f1966f7c15ba",
} :
  process.env.NODE_ENV === "production" ?
  {REDIRECT_URI: "https://nosecc.claude-apps.com/OAuthResponse",
    CLIENT_ID: "cd080f05-a33c-41e4-9180-8c9ad39bf5ba",
} : {} as never

const API_BASE = `https://${window.location.host}/`

export {REDIRECT_URI}
export {API_BASE}

export const LOGIN_URL = new URL("https://start.exactonline.nl/api/oauth2/auth")
LOGIN_URL.searchParams.set("client_id", CLIENT_ID)
LOGIN_URL.searchParams.set("redirect_uri", REDIRECT_URI)
LOGIN_URL.searchParams.set("response_type", "token")
LOGIN_URL.searchParams.set("force_login", "0")

export function getPurchaseOrderEOURL(division: number, purchaseOrderID: string): URL {
  const url = new URL(PURCHASEORDERURL)
  url.searchParams.set("EntryID", `{${purchaseOrderID}}`)
  url.searchParams.set("_Division_", "" + division)
  return url
}

export function getSalesOrderEOURL(division: number, salesOrderID: string): URL {
  const url = new URL(SALESORDERURL)
  url.searchParams.set("EntryID", `{${salesOrderID}}`)
  url.searchParams.set("_Division_", "" + division)
  return url
}

export function getWarehouseTransferEOURL(division: number, transferID: string): URL {
  const url = new URL(WAREHOUSETRANSFERURL)
  url.searchParams.set("EntryID", `{${transferID}}`)
  url.searchParams.set("_Division_", "" + division)
  return url
}

export function getPlannedSalesReturnEOURL(
  division: number, plannedSalesReturnID: string
): URL {
  const url = new URL(PLANNEDSALESRETURNURL)
  url.searchParams.set("ID", `{${plannedSalesReturnID}}`)
  url.searchParams.set("_Division_", "" + division)
  return url
}

